import { render, staticRenderFns } from "./resourceLibrary.vue?vue&type=template&id=66e10ee8&scoped=true&"
import script from "./resourceLibrary.vue?vue&type=script&lang=js&"
export * from "./resourceLibrary.vue?vue&type=script&lang=js&"
import style0 from "./resourceLibrary.vue?vue&type=style&index=0&id=66e10ee8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e10ee8",
  null
  
)

export default component.exports